// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"259":"5b57e755","751":"62b9c7fd"}[chunkId] + ".chunk.js";
};